The latitude of the geographical location.
